




















import Vue from 'vue';
import SFilters from '../../SFilters/SFilters.vue';

export default Vue.extend({
  name: 'STableFilter',
  components: {
    SFilters,
  },
  props: {
    showFilter: { type: Boolean },
    filterProps: { type: Object },
    filterLabel: { type: String },
  },
  data(): any {
    return {
      filter: '',
    };
  },
});
